<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12N37Y7/tc-custom/9781514004012.jpg?1696025897450" alt="This image is the cover for the book The Next Worship Bible Study, IVP Signature Bible Studies"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Next Worship Bible Study, IVP Signature Bible Studies
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>Our destiny, Scripture reveals, is worshiping together as the multiethnic, multilingual, multinational family of God.</strong> Our worship here on earth should reflect, point to, and prepare for that ultimate experience. </p> <p>In these five studies, Sandra Maria Van Opstal dives into biblical perspectives on worship that shaped her groundbreaking book <em>The Next Worship</em>. Focusing on key passages throughout the New Testament, she invites readers to consider how worship relates to diversity, reconciliation, hospitality, unity, and more.</p> <p>As companions to the IVP Signature Collection, IVP Signature Bible Studies help individuals and groups explore and apply biblical truths found in classic books. Each session features quotations from <em>The Next Worship</em> matched with Scripture passages, reflection questions, and application ideas that will equip readers to connect the text to their own lives. A leader's guide is also included.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sandra Maria Van Opstal
      </h2>
      
      <p class="authorDescription body article"><p>Sandra Maria Van Opstal is a second-generation Latina pastor, an activist, an author, and a powerful leading voice on the intersection of faith and justice. She is executive director of Chasing Justice, a movement that mobilizes Christians to live justly. Sandra’s distinctiveness comes from working in both local and global contexts as a practitioner and an academic. She has reached audiences around the world on topics of reconciliation, global justice, and worship.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?13e7b632